var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEditMode || _vm.showInReadMode)?_c('div',{staticClass:"error-container",class:{'relative': _vm.relative, 'is-edit-mode': _vm.isEditMode}},[_c('div',{staticClass:"content-error"},[_vm._v("Donnée non disponible")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }